var hasTag = function hasTag(tag) {
  return function (src) {
    return !!document.querySelector("".concat(tag, "[src=\"").concat(src, "\"]"));
  };
};
export default hasTag;